import { FileText, MapPin, TrendingUp, Handshake, Shield, Download } from "lucide-react";
import { useLocale } from "@/i18n/context";

const featureIcons = [FileText, TrendingUp, MapPin, Shield, Handshake, Download];

export const Features = () => {
  const { t } = useLocale();
  return (
    <section id="features" className="features-section scroll-mt-28">
      <div className="container mx-auto px-5 sm:px-8">
        <div className="features-layout">
          <div className="features-intro">
            <p className="editorial-eyebrow">{t.brand.featuresEyebrow}</p>
            <h2 className="section-title mt-4">{t.brand.featuresTitle}</h2>
            <p className="mt-5 text-base leading-relaxed text-muted-foreground">{t.brand.featuresDescription}</p>
            <div className="features-included"><span className="status-dot" />{t.brand.included}</div>
          </div>
          <div className="feature-list">
            {t.brand.featureItems.map((feature, index) => {
              const Icon = featureIcons[index];
              return (
                <article className="feature-item" key={feature.title}>
                  <div className="feature-item-top"><Icon className="h-5 w-5" aria-hidden="true" /><span>{String(index + 1).padStart(2, "0")}</span></div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
